import { Component, OnDestroy, OnInit } from '@angular/core';
import { first } from 'lodash-es';
import { combineLatest, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { DesignService, MouldDecisionToolService } from 'src/app/state';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'em-mould-decision-tool',
  styleUrls: ['./mould-decision-tool.component.less'],
  templateUrl: './mould-decision-tool.component.html',
  standalone: false,
})
export class MouldDecisionToolComponent implements OnInit, OnDestroy {
  public readonly designLoading$ = this.designService.loading$;
  public readonly mouldDecisionToolLoading$ = this.mouldDecisionToolService.loading$;
  public readonly error$ = this.mouldDecisionToolService.error$;
  public readonly mdt$ = this.mouldDecisionToolService.mouldDecisionTools$.pipe(map(first));

  public loading$ = combineLatest([this.designLoading$, this.mouldDecisionToolLoading$]).pipe(
    map(([designLoading, mouldDecisionToolLoading]) => designLoading || mouldDecisionToolLoading)
  );

  public siteUrl = environment.sharePointMDTSiteUrl;

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly designService: DesignService,
    private readonly mouldDecisionToolService: MouldDecisionToolService
  ) {}

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit() {
    this.subscriptions.add(this.mouldDecisionToolService.loadByActiveEquipmentNumber().subscribe());
  }
}
